import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SystemDefaultModel } from 'src/app/models/non-master-model/SystemDefaultModel';
import { DialogReplyService } from 'src/app/services/Non-Master/DialogReply.service';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { MastersKeyStringValue } from 'src/app/services/Non-Master/MastersKeyStringValue.service';
import { AppSettings } from 'src/app/shared/AppSettings';

@Component({
  selector: 'app-api-message-dialog',
  templateUrl: './api-message-dialog.component.html',
  styleUrls: ['./api-message-dialog.component.css']
})
export class ApiMessageDialogComponent implements OnInit {

  bntStyle: string;

  constructor(
    public activeModal: NgbActiveModal,
    private log: LoggerService,
    private router: Router,
    private dialogReplyService: DialogReplyService
  ) { }

  TAG = "ApiResultDialogComponent";
  // displayMsg: string;
  @Input() action: string;
  @Input() status: string;
  @Input() tableKeyValue: string;
  @Input() msg: string;
  @Input() options?: {isError:Boolean};


  isLoading = false;

  ngOnInit() {

    this.bntStyle = 'btn-default';

    switch (this.action) {
      case MastersKeyStringValue.ACTION_MessageDialog:
        this.setHideCancelButton();
        break;
      default:
        break;
    }

  }

  confirm() {
    this.log.i(this.TAG, "do confirm , action = " + this.action);
    this.isLoading = true;
    switch (this.action) {
      case MastersKeyStringValue.ACTION_NEW:
        this.doUpdateReturn(this.tableKeyValue);
        break;
      case MastersKeyStringValue.ACTION_UPDATE:
        // don't want to use it to control all edit dialog... too trouble
        this.doUpdateReturn(this.tableKeyValue);
        break;
      case MastersKeyStringValue.ACTION_DELETE:
        this.doDeleteReturn();
        // this.doUpdateReturn(this.tableKeyValue);
        break;
      case MastersKeyStringValue.ACTION_MessageDialog:
        this.activeModal.dismiss('OK');
        break;
      case MastersKeyStringValue.ACTION_MessageDialogReload:
        this.activeModal.close('Close click');
        break;
      case MastersKeyStringValue.ACTION_YNDialog:
        this.doReplyYes();
        break;
      case MastersKeyStringValue.ACTION_MessageDialogSucceed:
        this.activeModal.dismiss('OK');
        window.location.reload();
        break;
      case MastersKeyStringValue.ACTION_BillpayConfirmPackage:
        this.activeModal.close('OK');
        // window.location.reload();
        break;
      default:
        this.activeModal.close('Close click');
        break;
    }
  }

  cancel() {
    this.log.i(this.TAG, "do cancel");

    switch (this.action) {
      case MastersKeyStringValue.ACTION_YNDialog:
        this.doReplyNo();
        break;
      default:
        this.activeModal.dismiss('Close click');
        break;
    }
  }


  setHideCancelButton() {
    this.bntStyle = 'btn-hidden';
  }

  doDeleteReturn() {
    this.log.i(this.TAG, "do doDeleteReturn");
    this.activeModal.dismiss('OK');
    window.location.reload();
    // this.router.navigateByUrl('/tbed');
  }

  doReload() {
    this.log.i(this.TAG, "do doReload");
    this.activeModal.dismiss('OK');
    window.location.reload();
  }

  doUpdateReturn(tableKeyValue: string) {
    this.activeModal.dismiss('OK');

    // // window.location.reload();
    this.log.i(this.TAG, "do doUpdateReturn tableKeyValue = " + tableKeyValue);
    switch (tableKeyValue) {
      case MastersKeyStringValue.TABLE_Bed:
        this.router.navigate([AppSettings.Path_bed]);
        break;
      case MastersKeyStringValue.TABLE_Shop:
        this.router.navigate([AppSettings.Path_tShop]);
        break;
      case MastersKeyStringValue.TABLE_ShopBldg:
        this.router.navigate([AppSettings.Path_tShopBldg]);
        break;
      case MastersKeyStringValue.TABLE_PatientType:
        this.router.navigate([AppSettings.Path_tPatientType]);
        break;
      case MastersKeyStringValue.TABLE_Employee:
        this.router.navigate([AppSettings.Path_tEmployee]);
        break;
      case MastersKeyStringValue.TABLE_BookAux:
        this.router.navigate([AppSettings.Path_tBookAux]);
        break;
      case MastersKeyStringValue.TABLE_ItemCate:
        this.router.navigate([AppSettings.Path_tItemCate]);
        break;
      case MastersKeyStringValue.TABLE_Item:
        this.router.navigate([AppSettings.Path_tItem]);
        break;
      case MastersKeyStringValue.TABLE_Inbound:
        this.router.navigate([AppSettings.Path_Inbound]);
        break;
      case MastersKeyStringValue.TABLE_Outbound:
        this.router.navigate([AppSettings.Path_Outbound]);
        break;
      case MastersKeyStringValue.TABLE_Journal:
        this.router.navigate([AppSettings.Path_Journal]);
        break;
      default:
        break;
    }
  }

  doChange() {
    this.activeModal.dismiss('OK');
  }

  doReplyYes() {
    // this.dialogReplyService.doDialogReply('Y');
    this.activeModal.close('Y');
  }

  doReplyNo() {
    // this.dialogReplyService.doDialogReply('N');
    this.activeModal.close('N');
  }

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    // event.key === 'ArrowUp'
    if (event.key === SystemDefaultModel.SaveKey) {
      this.confirm();
    }
  }


}
